import { m as motion } from 'framer-motion';
import { ConnectedInput } from '@eti/form';
import { string, travelerInputs } from '@eti/utils';
import { css } from '@eti/styles';
import { breakpoints, vars } from '@etg/wings';
import { useProperty, useTranslation } from '@eti/providers';
import { useEffect } from 'react';
import { persistTaxId } from '../utils/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  TAX_ID_INPUT
} = travelerInputs;
const transition = {
  type: 'tween',
  duration: 0.2
};
const {
  colors: {
    divider: lightGray
  },
  card: {
    borderRadius
  }
} = vars;
const inputStyles = css`
  background-color: #fff;
  border-end-end-radius: ${borderRadius};
  border-end-start-radius: ${borderRadius};
  border-top: 1px solid ${lightGray};
  overflow: hidden;
  padding: 16px;

  span {
    height: auto;
    margin-top: 0;
  }
`;
const taxStyles = css`
  @media (min-width: ${breakpoints._768}) {
    width: 50%;
  }
`;
const expandVariants = {
  hidden: {
    maxHeight: 0,
    transition
  },
  visible: {
    maxHeight: '175px',
    transition
  }
};
const expandDefaults = {
  initial: 'hidden',
  animate: 'visible',
  transition: {
    duration: 0.35
  },
  style: {
    overflow: 'hidden'
  }
};
function TaxIdInput({
  taxId,
  onTaxIdChange
}) {
  const {
    t
  } = useTranslation();
  const {
    p
  } = useProperty();
  const taxIdLabel = p('Payment.TaxIdFeature.Label');
  const labelWithoutSlash = taxIdLabel === null || taxIdLabel === void 0 ? void 0 : taxIdLabel.replace('/', '');
  const taxIdInputTextHint = t(`Payment.TaxIdField.Input.Hint.${labelWithoutSlash}`);
  const taxIdInputTextLabel = string.insertArgument(t('Payment.TaxIdField.Input.Placeholder'), taxIdLabel) || `Enter your ${taxIdLabel} number`;
  useEffect(() => {
    onTaxIdChange(taxId);
  }, [onTaxIdChange, taxId]);
  return /*#__PURE__*/_jsx(motion.div, {
    ...expandDefaults,
    className: inputStyles,
    variants: expandVariants,
    children: /*#__PURE__*/_jsx(ConnectedInput, {
      autoCapitalize: "off",
      autoCorrect: "off",
      className: taxStyles,
      "data-testid": "cpf-textInput",
      description: taxIdInputTextHint,
      label: taxIdInputTextLabel,
      maxLength: 32,
      name: TAX_ID_INPUT,
      onChange: e => persistTaxId(e.target.value),
      spellCheck: "false",
      validationRuleName: TAX_ID_INPUT
    })
  });
}
export default TaxIdInput;
//# sourceMappingURL=TaxIdInput.js.map